import './faq-list.scss'

export const component = {
    name: 'faq-list',

    data: {
        index: -1
    },
}


// WEBPACK FOOTER //
// ./app/theme/components/faq-list/faq-list.js